import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const LoginContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  minHeight: "100vh",
  backgroundColor: theme.palette.background.default,
}));

export const LoginImageSection = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "none",
  backgroundColor: `${theme.palette.primary.main}08`,
  padding: theme.spacing(4),
  position: "relative",
  overflow: "hidden",

  "@media (min-width: 1024px)": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export const BrandLogo = styled(Typography)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(4),
  left: theme.spacing(4),
  fontSize: "1.5rem",
  fontWeight: 700,
  color: theme.palette.primary.main,
}));

export const ImageWrapper = styled(Box)(({ theme }) => ({
  maxWidth: 480,
  marginBottom: theme.spacing(4),
  position: "relative",

  "& img": {
    width: "100%",
    height: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.standard,
    }),
  },

  "&:hover img": {
    transform: "scale(1.02)",
  },
}));

export const LoginFormSection = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(4),
  maxWidth: 480,
  margin: "0 auto",

  "@media (min-width: 1024px)": {
    padding: theme.spacing(6),
  },
}));

export const LoginCard = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: 360,
  padding: theme.spacing(3),
  borderRadius: 16,
  backgroundColor: theme.palette.background.paper,
  boxShadow: "0 4px 24px rgba(0, 0, 0, 0.08)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.standard,
  }),
}));

export const LoginForm = styled("form")({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const WelcomeText = styled(Typography)(({ theme }) => ({
  fontSize: "1.5rem",
  fontWeight: 600,
  color: theme.palette.text.primary,
  textAlign: "center",
}));

export const SubText = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  color: theme.palette.text.secondary,
  fontSize: "0.875rem",
  marginBottom: theme.spacing(2),
}));

export const MicrosoftButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  padding: "12px 24px",
  backgroundColor: "#fff",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  fontSize: "1rem",
  fontWeight: 500,
  color: theme.palette.text.primary,
  cursor: "pointer",
  transition: theme.transitions.create(["background-color", "box-shadow"], {
    duration: theme.transitions.duration.short,
  }),
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",

  "&:hover": {
    backgroundColor: theme.palette.action.hover,
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },

  "&:active": {
    transform: "translateY(1px)",
  },
}));
